module.exports = __webpack_public_path__ + "static/media/icon-view-unhappy.7f95ed40.svg";